/**
 * Created by slava on 3/28/17.
 */

cleverapps.Settings = function () {
    cleverapps.EventEmitter.call(this);

    this.onChangeSoundListener = function () {
    };

    this.onChangeMusicListener = function () {
    };

    this.onChangeVibrationListener = function () {
    };

    this.load();

    if (connector.platform.hasAudioControls) {
        this.sound = true;
        this.music = true;
    }
};

cleverapps.Settings.prototype = Object.create(cleverapps.EventEmitter.prototype);
cleverapps.Settings.prototype.constructor = cleverapps.Settings;

cleverapps.Settings.getDefaultLanguage = function () {
    const languages = cleverapps.config.languages;
    if (languages.length === 1) {
        return languages[0];
    }

    const userLang = connector.info.language;
    if (languages.indexOf(userLang) === -1) {
        return connector.LANGUAGE_ENGLISH;
    }

    return userLang;
};

cleverapps.Settings.prototype.getSaveInfo = function () {
    return {
        sound: this.sound,
        music: this.music,
        vibrate: this.vibrate,
        language: this.language,
        avatar: this.avatar,
        nickname: this.nickname
    };
};

cleverapps.Settings.prototype.updateInfo = function (serverData) {
    serverData = serverData || {};

    this.avatar = serverData.avatar;
    this.nickname = serverData.nickname;

    this.save(true);
};

cleverapps.Settings.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.SETTINGS, this.getSaveInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("settings");
    }
};

cleverapps.Settings.prototype.loadData = function (info) {
    if (info === undefined) {
        info = {};
    }

    this.sound = info.sound !== undefined ? info.sound : true;
    this.music = info.music !== undefined ? info.music : true;
    this.vibrate = info.vibrate !== undefined ? info.vibrate : true;
    this.language = info.language || cleverapps.Settings.getDefaultLanguage();
    this.avatar = info.avatar || undefined;
    this.nickname = info.nickname || undefined;
    this.manualResolution = info.manualResolution;
    if (this.manualResolution) {
        cleverapps.resolution.resolutionName = this.manualResolution;
    }

    if (this.avatar && this.avatar.startsWith(`${cleverapps.config.deployment}/info/user/avatar/`)) {
        const avatars = cleverapps.UI.Avatar.GetAvatarFramesNames();
        const index = parseInt(this.avatar.replace(`${cleverapps.config.deployment}/info/user/avatar/`, ""));

        this.avatar = avatars[index] ? `#avatars/${avatars[index]}.png` : undefined;
    }

    connector.info.changeLanguage(this.language);

    this.updateTesterCountry();
};

cleverapps.Settings.prototype.load = function () {
    const info = cleverapps.dataLoader.load(DataLoader.TYPES.SETTINGS);
    this.loadData(info);
};

cleverapps.Settings.prototype.toggleSound = function () {
    this.sound = !this.sound;

    console.log("Settings toggle sound", this.sound, cc.game.isPaused());

    this.save();
    this.onChangeSoundListener();
};

cleverapps.Settings.prototype.toggleMusic = function () {
    this.music = !this.music;
    cleverapps.audio.onChangeMusic();

    console.log("Settings toggle music", this.music, cc.game.isPaused());

    this.save();
    this.onChangeMusicListener();
};

cleverapps.Settings.prototype.toggleVibration = function () {
    this.vibrate = !this.vibrate;
    if (this.vibrate) {
        cleverapps.effects.fire("ui.settings.vibrate.on");
    }

    console.log("Settings toggle vibration", this.vibrate, cc.game.isPaused());

    this.save();
    this.onChangeVibrationListener();
};

cleverapps.Settings.prototype.setLanguage = function (language) {
    this.language = language;
    this.save();

    connector.info.changeLanguage(this.language);
    this.trigger("updateLanguage");

    this.updateTesterCountry();
};

cleverapps.Settings.prototype.setAvatar = function (avatar) {
    if (avatar === this.avatar) {
        return;
    }

    this.avatar = avatar;
    this.save();
    this.trigger("changedAvatar");

    cleverapps.user.incProgressCompare(10);
};

cleverapps.Settings.prototype.getDefaultAvatar = function () {
    return typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()
        ? `#avatars/${cleverapps.UI.Avatar.GetAvatarFramesNames()[0]}.png`
        : connector.player.avatar;
};

cleverapps.Settings.prototype.getAvatar = function () {
    const avatar = typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()
        ? this.avatar : undefined;

    return avatar || this.getDefaultAvatar();
};

cleverapps.Settings.prototype.generateName = function () {
    const nicknames = [];
    for (let i = 0; Messages.has(`Nickname_${i}`); i++) {
        nicknames.push(Messages.get(`Nickname_${i}`));
    }

    let nickname = `${PseudoRandom.GET().choose(nicknames)}`;

    if (!nickname) {
        nickname = `${Messages.get("Player")}_${connector.platform.getUserID().slice(-3)}`;
    }

    return nickname;
};

cleverapps.Settings.prototype.getDefaultNickname = function () {
    return connector.player.name || `${Messages.get("Player")}_${connector.platform.getUserID().slice(-3)}`;
};

cleverapps.Settings.prototype.getNickname = function () {
    const nickname = typeof ProfileWindow !== "undefined" && ProfileWindow.IsSelectionAvailable()
        ? this.nickname : undefined;

    return nickname || this.getDefaultNickname();
};

cleverapps.Settings.prototype.setNickname = function (name) {
    if (name === this.nickname) {
        return;
    }

    this.nickname = name;
    this.save();

    this.trigger("changedNickname");

    cleverapps.user.incProgressCompare(10);
};

cleverapps.Settings.prototype.updateTesterCountry = function () {
    if (connector.platform.isTester()) {
        if (this.language === connector.LANGUAGE_RUSSIAN) {
            connector._countryManager.forceCountry("RU");
        } else {
            connector._countryManager.forceCountry("OTHER");
        }
    }
};

cleverapps.Settings.prototype.updateDependents = function () {
    if (cleverapps.config.type === "board") {
        levels.user.resetEpisodesAmount();
    }

    if (cleverapps.playButton) {
        cleverapps.playButton.update();
    }
};

cleverapps.Settings.prototype.setManualResolution = function (manualResolution) {
    this.manualResolution = manualResolution;
    const info = this.getSaveInfo();
    info.manualResolution = this.manualResolution;
    cleverapps.dataLoader.save(DataLoader.TYPES.SETTINGS, info);
    cleverapps.dataLoader.processSaveQueue();

    window.location.reload();
};
